import type { Parameters } from "@/services/collection/parameters";
import { type ItemParameterChangeDataWrapper } from "@/types";
import { onMounted, onUnmounted } from "vue";
import { EventBus, Event } from "@/services/eventBus";

export function useConditionalParams(parameter: Parameters.Parameter) {
  const isConditional = parameter.conditionalParameterId !== undefined;
  const isAvailable = ref(isConditional ? false : true);

  onMounted(() => {
    if (isConditional) {
      EventBus.on(Event.CollectionParamsChanged, checkAvailability);
    }
  });

  onUnmounted(() => {
    if (isConditional) {
      EventBus.off(Event.CollectionParamsChanged, checkAvailability);
    }
  });

  const checkAvailability = (change: ItemParameterChangeDataWrapper) => {
    if (change.parameterId !== parameter.conditionalParameterId) {
      return; // This change does not affect our parameter
    }

    isAvailable.value = parameter.conditionalParameterId === change.parameterId && parameter.conditionalValueId === change.valueId;
  };

  return {
    isAvailable,
  };
}
